/**
 * Interprets an ISO datetime string (without offset) as UTC+2
 * and returns a Date object in the user's local timezone.
 *
 * Example: "2026-03-30T19:00:00" → Date representing 17:00 UTC → local time
 */
export const parseUtc2AsLocal = (isoString: string): Date =>
  new Date(`${isoString}+02:00`);
